import { get } from "../../../utils/axios-config";
import {CURRENT_ACADEMICYEAR } from "../../../utils/constants";
import { AcademicYearType } from "../../../types/AcademicYear";

export const getCurrentAcademicYear = async () => {
    return await get<AcademicYearType>(CURRENT_ACADEMICYEAR)
};